<div class="modal-form container">
    <h1 mat-mdc-dialog-title class="jumbotron-heading ">{{data.title}}</h1>
    <mat-dialog-content>
        <ng-container *ngIf="error" class="container error">
            <div class="container">
                <mat-list role="list" *ngFor="let err of error.Email  ">
                    <mat-list-item role="listitem">* {{err}}</mat-list-item>
                </mat-list>
                <!-- <mat-list role="list" *ngFor="let err of error.OrganizationId ">
                    <mat-list-item role="listitem">* {{err}}</mat-list-item>
                </mat-list> -->
            </div>
        </ng-container>
        <!-- <div class="navigation-mode"> -->
        <p *ngIf="isDataContentVisible(data.content)">{{data.content}}</p>

        <ng-template #target></ng-template>
        <!-- </div> -->
    </mat-dialog-content>
    <mat-dialog-actions class="dialog-actions row">
        <lgv-loading-indicator *ngIf="IsLoading$ | async"></lgv-loading-indicator>
        <div class="col-12" align="end">
            <button *ngIf="data.startButtonText" class="btn btn-primary float-end"
                    (click)="clickTrigger(data.startButtonKey)">
                {{data.startButtonText}}
            </button>
            <button *ngIf="data.endButtonText" (click)="close()" class="btn btn-secondary float-end">
                {{data.endButtonText}}
            </button>

        </div>
    </mat-dialog-actions>

</div>
